module.exports = __webpack_public_path__ + "img/shot_tx19112002.82eb6c46.jpg";